import LinkButton from 'components/shared/button/LinkButton';
import GNEModal from 'components/shared/modal/Modal';
import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { buildFilterPayload, getAccessibleFilters } from 'utils/utils';
import { renameInsightView } from 'store/customer/customer-view-actions';
import {
  setAllInsightView,
  setSaveInsightViewBtnState,
  setSelectedInsightView,
} from 'store/customer/customerViewSlice';
import { toast } from 'react-toastify';
import classes from './SectionMenu.module.scss';
import { BUTTON_STATE } from 'constants/constants';

function SaveConfirmationModal(props) {
  const dispatch = useDispatch();

  const selectedInsightView = useSelector(
    (state) => state?.CustomerView?.selectedInsightView
  );
  const engagementFilters = useSelector(
    (state) => state?.CustomerView?.engagementFilters
  );
  const sitePerformanceFilters = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters
  );
  const siteUtilizationFilters = useSelector(
    (state) => state?.CustomerView?.siteUtilizationFilters
  );
  const AffiliationFilter = useSelector(
    (state) => state?.CustomerView?.affiliationsFilters
  );
  const copayAnalyticsFilters = useSelector(
    (state) => state?.CustomerView?.copayAnalyticsFilters
  );
  const productMixFilters = useSelector(
    (state) => state?.CustomerView?.productMixFilters
  );
  const payerMixFilters = useSelector(
    (state) => state.CustomerView?.payerMixFilters
  );
  const policyDetailsFilters = useSelector(
    (state) => state.CustomerView?.policyDetailsFilters
  );
  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );
  const selectedView = useSelector(
    (state) => state?.CustomerView?.selectedView
  );
  const componentAccessList = useSelector(
    (state) => state?.Auth?.componentAccessList
  );

  const handleCloseModal = () => {
    props.onHide();
  };

  const handleSave = async () => {
    let filters = {
      Engagements: engagementFilters,
      SitePerformance: sitePerformanceFilters,
      SiteUtilization: siteUtilizationFilters,
      Affiliations: AffiliationFilter,
      CopayAnalytics: copayAnalyticsFilters,
      ProductMix: productMixFilters,
      PayerMix: payerMixFilters,
      PolicyDetails: policyDetailsFilters,
    };
    // Get only those filters whose keys are NOT present in componentAccessList
    filters = getAccessibleFilters(filters, componentAccessList, selectedView);

    const payload = {
      id: selectedInsightView?.Id,
      filters: buildFilterPayload(filters),
    };
    await renameInsightView(payload)
      .then(() => {
        const updatedViews = allInsightViews.map((item) => {
          if (item.Id === selectedInsightView?.Id) {
            dispatch(setSelectedInsightView({ ...item, filters: filters }));
            return { ...item, filters: filters };
          }
          return item;
        });
        dispatch(setAllInsightView(updatedViews));
        dispatch(setSaveInsightViewBtnState(BUTTON_STATE.DISABLED));
        toast.success('View changes saved successfully');
        props.onHide();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const title = (
    <div className='d-flex px-3 pt-2'>
      <i className='icon icon__save_icon save_black lg mt-1'></i>
      <p className='text text__bold title__medium'>Save View</p>
    </div>
  );

  const content = (
    <div className='px-3 pb-3'>
      <span className='text text__small '>
        There are unsaved changes to your insight board view listed below. Would
        you like to save these changes and proceed?
      </span>
      <div className='mt-4 mb-5 '>
        <Form.Group as={Col}>
          <Form.Control
            type='text'
            value={selectedInsightView?.name}
            readOnly
            className={`text text__bold ${classes['save-view-field']}`}
            tabIndex={-1}
            onMouseDown={(e) => e.preventDefault()}
          />
        </Form.Group>
      </div>
      <div className={`d-flex justify-content-end`}>
        <LinkButton
          className='text text__small'
          onClick={handleCloseModal}>
          Cancel
        </LinkButton>

        <Button
          variant='btn btn-gne btn-primary'
          onClick={handleSave}
          className={`text__small ms-3`}>
          Yes
        </Button>
      </div>
    </div>
  );

  return (
    <GNEModal
      show={props.show}
      onHide={props.onHide}
      content={content}
      titlecontent={title}
      css={`size-medium`}
    />
  );
}

export default SaveConfirmationModal;
